/**
 * Not Found fallback route.
 *
 * Catches unmatched deep links (dramadetector://unknown-path) and
 * web URLs that don't match any route. Redirects to home after 2s.
 *
 * NocoDB #2914
 */
import { useEffect } from 'react';
import { View, Text } from 'react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from '@dramadetector/shared';

export default function NotFoundScreen() {
  const router = useRouter();
  const { t } = useTranslation('common');

  useEffect(() => {
    const timer = setTimeout(() => {
      router.replace('/');
    }, 2000);
    return () => clearTimeout(timer);
  }, [router]);

  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#0a0012' }}>
      <Text style={{ color: '#ffffff', fontSize: 18, marginBottom: 8 }}>{t('not_found.title')}</Text>
      <Text style={{ color: '#888888', fontSize: 14 }}>{t('not_found.redirecting')}</Text>
    </View>
  );
}
